import React, { useState, useEffect } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import Dimensions from "react-dimensions";
import { connect } from "react-redux";
import {
  getCustomers,
  setCustomersFilter,
  setCustomer,
  deleteCustomer,
  navigateToCustomerDone,
  exportCustomers,
} from "./bowlers.redux";
import SearchSection from "../ui/SearchSection";
import { useTranslation } from "react-i18next";
import Spinner from "../ui/Spinner";
import { woocommerceCheckUserExists } from "../plugins/plugin.redux";
import {
  specsheetBatchOpen,
  specsheetBatchClose,
} from "../specsheet/specsheet.redux";

const BowlersScreen = ({
  containerWidth,
  containerHeight,
  customers,
  getCustomers,
  setCustomersFilter,
  setCustomer,
  deleteCustomer,
  loadingCustomers,
  currentPage,
  userId,
  filter,
  orderBy,
  hasMore,
  navigateToCustomer,
  navigateToCustomerDone,
  deviceInfo,
  isReadOnly,
  exportCustomers,
  current_woocommerce_id,
  woocommerceCheckUserExists,
  pluginSubscriptions,
  specsheetBatchOpen,
  specsheetBatchClose,
  scanPending,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const bowlers = customers;
  const isPortrait = deviceInfo.isPortrait;

  useEffect(() => {
    if (!loadingCustomers && filter === "" && currentPage === 0) {
      getCustomers({});
    } else {
      getCustomers({ loadMore: false, offset: 0 });
    }
  }, []);

  // Asks once for the scan queue so the button can say how much is waiting,
  // and keeps asking only while something is still being read -- which is
  // what the poll epic already does on its own. Standing still, it is one
  // request per visit to this list.
  useEffect(() => {
    specsheetBatchOpen({});
    return () => specsheetBatchClose();
  }, []);

  useEffect(() => {
    if (navigateToCustomer) {
      navigate(`/bowler/${navigateToCustomer}`);
      navigateToCustomerDone();
    }
  }, [navigateToCustomer]);

  return loadingCustomers && bowlers.length === 0 ? (
    <Spinner />
  ) : (
    <SearchSection
      bowlers={bowlers}
      userId={userId}
      getCustomers={getCustomers}
      setCustomersFilter={setCustomersFilter}
      setCustomer={setCustomer}
      deleteCustomer={deleteCustomer}
      isLoadingMore={loadingCustomers}
      hasMore={hasMore}
      filter={filter}
      orderBy={orderBy}
      isPortrait={isPortrait}
      isReadOnly={isReadOnly}
      exportCustomers={exportCustomers}
      current_woocommerce_id={current_woocommerce_id}
      woocommerceCheckUserExists={woocommerceCheckUserExists}
      pluginSubscriptions={pluginSubscriptions}
      onScanQueue={() => navigate("/scan")}
      scanPending={scanPending}
    />
  );
};

export default Dimensions({
  containerStyle: {
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",
    padding: 0,
  },
})(
  connect(
    (state) => ({
      customers: state.bowlers.customers,
      loadingCustomers: state.bowlers.loadingCustomers,
      userId: state.userSession.userData.id,
      filter: state.bowlers.filter,
      orderBy: state.bowlers.orderBy,
      hasMore: state.bowlers.hasMore,
      currentPage: state.bowlers.offset,
      navigateToCustomer: state.bowlers.navigateToCustomer,
      deviceInfo: state.userSession.deviceInfo,
      isReadOnly: state.userSession.isReadOnly,
      current_woocommerce_id:
        state.plugin.plugin_settings.current_woocommerce_id,
      pluginSubscriptions: state.plugin.pluginSubscriptions,
      // Sheets read and not yet turned into a bowler's sheet. Anything still
      // being read is deliberately left out: a number that fell on its own as
      // each page finished would read as work being done without anyone
      // touching it.
      scanPending: state.specsheet.batchJobs.filter(
        (job) =>
          job.status === "done" && !state.specsheet.batchApplied[job.jobId],
      ).length,
    }),
    {
      getCustomers,
      setCustomersFilter,
      setCustomer,
      deleteCustomer,
      navigateToCustomerDone,
      exportCustomers,
      woocommerceCheckUserExists,
      specsheetBatchOpen,
      specsheetBatchClose,
    }
  )(BowlersScreen)
);
